import React from "react";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core";
import { useCookieConsent } from "../../../privacy/CookieConsentContext";

export default function Footer() {
  const classes = useStyle();
  const { openPreferences } = useCookieConsent();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <div className={classes.title}>
        <p className={classes.riskNotice}>
          $OXYZ is a crypto-asset. Crypto-assets may lose some or all of their
          value. This website provides information about the Oxya Origin gaming
          ecosystem only. It is not investment advice or a promise of value,
          liquidity, income or returns. Gameplay features, utility, rewards and
          availability may change, be limited or be discontinued, subject to the
          applicable rules and terms.
        </p>
        <p>
          Contract $OXYZ in Eth network:
          <span style={{ fontWeight: 600 }}>
            {" "}
            0xD0623da373F754C4B6762209EA77De59B21DD667
          </span>
        </p>
        <p>
          Contract $OXYZ in Immutable zkEVM network:
          <span style={{ fontWeight: 600 }}>
            {" "}
            0x5178fb04a0F469C7d309144B439640c9c1EBa11c
          </span>
        </p>
        <p className={classes.copyright}>
          © {currentYear} ORIGIN GAME. OXYA ORIGIN and related content are
          protected by applicable intellectual-property laws. Third-party marks
          remain the property of their respective owners.
        </p>
      </div>

      <div className={classes.wrapperContent}>
        <div>
          <strong>Resources</strong>
          <a
            href="https://drive.google.com/drive/folders/16O1akt2qa7zVQpiAbpxubeKIdIZCfNd6"
            target="_blank"
            rel="noreferrer"
          >
            Media Kit
          </a>
          <a
            href="https://oxya-origin.gitbook.io/oxya-origin/"
            target="_blank"
            rel="noreferrer"
          >
            Whitepaper
          </a>
          <a href="https://app.oxyaorigin.com">Oxya App</a>
        </div>
        <div>
          <strong>Company</strong>
          <Link to="/terms">Terms</Link>
          <Link to="/terms/rtg">Terms Road To Genesis</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/cookie-policy">Cookie Policy</Link>
          <Link to="/legal-notice">Legal Notice</Link>
          <button
            className={classes.footerButton}
            type="button"
            onClick={openPreferences}
          >
            Cookie Settings
          </button>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSddpXHHX3b4Lqx88uaItMyEswIY7pBYawwVlKgHg1pgAztIzg/viewform"
            target="_blank"
            rel="noreferrer"
          >
            Partnership
          </a>
          contact@oxyaorigin.com
        </div>
        <div>
          <strong>Social</strong>
          <a
            href="https://discord.gg/2cm5kJURRh"
            target="_blank"
            rel="noreferrer"
          >
            Discord
          </a>
          <a
            href="https://twitter.com/OxyaOrigin"
            target="_blank"
            rel="noreferrer"
          >
            X
          </a>
          <a
            href="https://www.youtube.com/channel/UCLv4c_vOHTDueESoMiIaDAg"
            target="_blank"
            rel="noreferrer"
          >
            YouTube
          </a>
          <a
            href="https://linktr.ee/Oxyaorigin"
            target="_blank"
            rel="noreferrer"
          >
            All Links
          </a>
        </div>
      </div>
    </footer>
  );
}

const useStyle = makeStyles(({ breakpoints }) => ({
  footer: {
    paddingLeft: "10rem",
    margin: "4rem auto",
    width: "90%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [breakpoints.down("sm")]: {
      paddingLeft: 0,
    },
  },
  title: {
    fontSize: "1.2rem",
    textTransform: "uppercase",
    color: "white",
    textAlign: "center",
  },
  riskNotice: {
    margin: "0 auto 2rem",
    maxWidth: "80rem",
    lineHeight: 1.5,
    textTransform: "none",
  },
  copyright: {
    marginTop: "1rem",
  },
  footerButton: {
    padding: 0,
    color: "white",
    background: "transparent",
    border: 0,
    font: "inherit",
    lineHeight: "inherit",
    textAlign: "left",
    cursor: "pointer",
    transition: "0.2s opacity ease-in-out",
    "&:hover": {
      opacity: 0.8,
    },
  },
  wrapperContent: {
    marginTop: "2rem",
    display: "flex",
    fontSize: "0.75rem",
    lineHeight: "1.2rem",
    color: "white",
    gap: "1.25rem",
    justifyContent: "space-evenly",
    "& div": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      fontSize: "1rem",
      "& strong": {
        fontSize: "1.4rem",
        marginBottom: "0.5rem",
      },
      "& a": {
        color: "white",
        textDecoration: "none",
        transition: "0.2s opacity ease-in-out",
        "&:hover": {
          opacity: 0.8,
        },
      },
    },
  },
}));
